import React from 'react';
import { useNavigate } from 'react-router-dom';

export const TERMS_VERSION = '2026-03-15';

const TermsOfService: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-md p-8">
        <button
          onClick={() => navigate(-1)}
          className="mb-6 text-orange-700 hover:text-orange-800 flex items-center gap-1"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Wróć
        </button>

        <h1 className="text-3xl font-bold text-gray-900 mb-2">Regulamin</h1>
        <p className="text-sm text-gray-500 mb-8">Ostatnia aktualizacja: 15 marca 2026</p>

        <div className="prose prose-gray max-w-none space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Postanowienia ogólne</h2>
            <p className="text-gray-700 leading-relaxed">
              Niniejszy regulamin określa zasady korzystania z aplikacji Złomiarz (dalej: "Aplikacja"),
              prowadzonej przez Daniel Kuśmider, z siedzibą przy ul. Marii Konopnickiej 61/18,
              30-302 Kraków, NIP: 7922234750 (dalej: "Usługodawca").
            </p>
            <p className="text-gray-700 leading-relaxed">
              Aplikacja służy do zarządzania dokumentacją punktu skupu złomu, w tym tworzenia kwitów skupu,
              zarządzania bazą klientów i produktów oraz generowania raportów.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Warunki korzystania</h2>
            <p className="text-gray-700 leading-relaxed">
              Korzystanie z Aplikacji wymaga utworzenia konta użytkownika poprzez podanie adresu e-mail
              i hasła. Użytkownik zobowiązuje się do podania prawdziwych danych oraz do zachowania
              poufności swoich danych logowania.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Użytkownik ponosi pełną odpowiedzialność za wszelkie działania wykonywane za pośrednictwem
              swojego konta.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Zakres usług</h2>
            <p className="text-gray-700 leading-relaxed">Aplikacja umożliwia:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-1">
              <li>Tworzenie i zarządzanie kwitami skupu</li>
              <li>Prowadzenie bazy klientów</li>
              <li>Zarządzanie katalogiem produktów i kategorii</li>
              <li>Generowanie raportów i statystyk</li>
              <li>Eksport danych do formatu PDF i Excel</li>
              <li>Pracę w trybie offline z automatyczną synchronizacją</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Odpowiedzialność</h2>
            <p className="text-gray-700 leading-relaxed">
              Usługodawca dokłada wszelkich starań, aby Aplikacja działała prawidłowo i bez zakłóceń.
              Usługodawca nie ponosi odpowiedzialności za przerwy w działaniu Aplikacji wynikające
              z przyczyn technicznych, konserwacji lub siły wyższej.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Użytkownik jest odpowiedzialny za prawidłowość danych wprowadzanych do Aplikacji.
              Usługodawca nie ponosi odpowiedzialności za skutki wynikające z wprowadzenia
              nieprawidłowych danych.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Rozwiązanie umowy</h2>
            <p className="text-gray-700 leading-relaxed">
              Użytkownik może w każdej chwili zrezygnować z korzystania z Aplikacji.
              Usługodawca zastrzega sobie prawo do zawieszenia lub usunięcia konta użytkownika
              w przypadku naruszenia niniejszego regulaminu.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Zmiany regulaminu</h2>
            <p className="text-gray-700 leading-relaxed">
              Usługodawca zastrzega sobie prawo do zmiany niniejszego regulaminu. O wszelkich zmianach
              użytkownicy zostaną poinformowani za pośrednictwem Aplikacji. Dalsze korzystanie z Aplikacji
              po wprowadzeniu zmian oznacza akceptację nowego regulaminu.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Postanowienia końcowe</h2>
            <p className="text-gray-700 leading-relaxed">
              W sprawach nieuregulowanych niniejszym regulaminem zastosowanie mają przepisy prawa polskiego.
              Wszelkie spory będą rozstrzygane przez sąd właściwy dla siedziby Usługodawcy.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Kontakt: <a href="mailto:kusmiderdaniel@gmail.com" className="text-orange-700 hover:text-orange-800">kusmiderdaniel@gmail.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
